<template>
  <Row style="width:100%height: 100%;" type="flex">
    <Col style="overflow-y: auto;height: 100%;flex: 1">
    <Card dis-hover style="background:#e3e8ee;min-height: 100%">
      <Tabs v-model="tabsNum" type="card" @on-click="initImageTools">
        <TabPane name="0" label="就诊历史">
          <div v-if="tabsNum == 0" style="overflow-y: auto;" :style="{height: wrapHeight + 'px'}">
            <diagnose-history></diagnose-history>
          </div>
        </TabPane>
        <TabPane name="1" label="问卷结果">
          <div v-if="tabsNum == 1" style="overflow-y: auto;" :style="{height: wrapHeight + 'px'}">
            <Card style="margin: 10px 0" v-if="unAnswerQuestionnaire != null && unAnswerQuestionnaire.length >0">
              <p slot="title">患者待填写问卷
                <Button type="primary" shape="circle" style="margin-left: 20px" icon="ios-pulse-outline" @click="remindUserToAnswer()" :disabled="sendMessage">发送短信提醒他</Button>
              </p>
              <div>
                <List border style="flex: 1" v-for="questionnaire in unAnswerQuestionnaire" :key="questionnaire.id">
                  <ListItem>
                    <div class="group-row" style="justify-content: space-between">
                      <p style="color: rgb(136, 135, 135)">{{questionnaire.name}}</p>
                    </div>
                  </ListItem>
                </List>
              </div>
            </Card>
            <Card>
              <p slot="title">患者已填写问卷</p>
              <Collapse accordion v-if="questionnaireResultList != null && questionnaireResultList.length > 0">
                <Panel :key="questionnaireResultInfo.id" v-for="questionnaireResultInfo in questionnaireResultList">
                  {{questionnaireResultInfo.name}}
                  <div slot="content">
                    <p class="questionnaireTitle">{{questionnaireResultInfo.name}}</p>
                    <h4 style="text-align: center;padding: 10px 0px">{{questionnaireResultInfo.introduction}}</h4>
                    <Divider>
                    <span style="font-size: 20px;color: #2d8cf0">
                        分数：{{questionnaireResultInfo.point}}
                    </span>
                    </Divider>
                    <div class="questionnaireQuestion">
                      <div style="width: 100%;padding: 15px 0" v-for="question in questionnaireResultInfo.questionVOList"
                           :key="question.id">
                        <div class="questionTitle">
                          <label v-if="question.required" style="color: red;position: absolute">*</label>
                          <div style="padding-left: 15px">
                            {{question.index}}、{{question.text}}
                            <span style="font-size: 16px;color: #B4B4B4;padding-left: 10px">({{question.type}})</span>
                          </div>
                        </div>
                        <div v-if="question.type == '文本'">
                          <div class="my_divz">{{question.optionList[0].answer}}</div>
                        </div>
                        <div v-if="question.type == '单选'">
                          <div style="padding-left: 30px">
                            <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList"
                                 style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                          <span v-if="Option.isSelected" class="input_iocns">
                                              <i class="iconfont" style="font-size: 16px">&#xe735;</i>
                                          </span>
                              <span v-if="!Option.isSelected" class="input_iocns">
                                              <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                          </span>
                              <span style="font-size: 18px;padding-left: 10px">{{Option.text}}</span>
                            </div>
                          </div>
                        </div>
                        <div v-if="question.type == '多选'">
                          <div style="padding-left: 30px">
                            <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList"
                                 style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                          <span v-if="Option.isSelected" class="input_iocns">
                                              <i class="iconfont" style="font-size: 16px">&#xe738;</i>
                                          </span>
                              <span v-if="!Option.isSelected" class="input_iocns">
                                              <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                          </span>
                              <span style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                            </div>
                          </div>
                        </div>
                        <div v-if="question.type == '单选文本'">
                          <div style="padding-left: 30px">
                            <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList"
                                 style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                          <span v-if="Option.isSelected" class="input_iocns">
                                              <i class="iconfont" style="font-size: 16px">&#xe735;</i>
                                          </span>
                              <span v-if="!Option.isSelected" class="input_iocns">
                                              <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                          </span>
                              <span v-if="Option.format ==''"
                                    style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                              <span v-if="Option.format !=''"
                                    style="font-size: 18px;padding-left: 10px;position: absolute;">
                                              <div v-if="Option.answer ==''" class="my_divz"
                                                   style="width: 200px;background-color: #f5f5f5">{{Option.answer}}</div>
                                              <div v-if="Option.answer !=''" class="my_divz" style="width: 200px">{{Option.answer}}</div>
                                          </span>
                            </div>
                          </div>
                        </div>
                        <div v-if="question.type == '多选文本'">
                          <div style="padding-left: 30px">
                            <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList"
                                 style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                          <span v-if="Option.isSelected" class="input_iocns">
                                              <i class="iconfont" style="font-size: 16px">&#xe738;</i>
                                          </span>
                              <span v-if="!Option.isSelected" class="input_iocns">
                                              <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                          </span>
                              <span v-if="Option.format ==''"
                                    style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                              <span v-if="Option.format !=''"
                                    style="font-size: 18px;padding-left: 10px;position: absolute;">
                                              <div v-if="Option.answer ==''" class="my_divz"
                                                   style="width: 200px;background-color: #f5f5f5">{{Option.answer}}</div>
                                              <div v-if="Option.answer !=''" class="my_divz" style="width: 200px">{{Option.answer}}</div>
                                          </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Divider>
                    <span style="font-size: 20px;color: #2d8cf0">
                        填写时间：{{questionnaireResultInfo.resultTime | dateTimeToString}}
                    </span>
                    </Divider>
                  </div>
                </Panel>
              </Collapse>
              <div v-else style="text-align: center">暂无已填写问卷</div>
            </Card>
            <Card>
              <p slot="title">患者历史已填写问卷</p>
              <div>
                <!--<Button type="primary" shape="circle" icon="md-add" style="margin: 0 auto" @click="goQuestionnaireResult()">去查看</Button>-->
                <div style="display: flex;justify-content: center">
                  <Button type="primary" shape="circle" icon="md-add" style="margin: 0 auto" @click="modalDisplay = true">去查看</Button>
                </div>
                <!--<router-link to="/patientQuestionnaireResult">去查看</router-link>-->
              </div>
            </Card>
          </div>
        </TabPane>
        <TabPane name="2" label="检测报告">
          <div v-if="tabsNum == 2" style="overflow-y: auto;" :style="{height: wrapHeight + 'px'}" id="imgToolsHistory">
            <Card style="margin: 10px 0">
              <p slot="title">患者检测报告</p>
              <Row>
                <div class="group-row">
                  <div v-for="(item, index) in caseInfo.病情相关的检查结果">
                    <!--<img :src="item" style="max-height: 120px;max-width: 100%;margin: 10px">-->
                    <img :data-original='`${item}`' :src="item" style="max-height: 120px;max-width: 100%;margin: 10px">
                  </div>
                </div>
              </Row>
            </Card>
            <Card style="margin: 10px 0">
              <p slot="title">系统检测报告</p>
              <Timeline pending>
                <TimelineItem v-for="(item, index) in systemReport" :key="index">
                  <p class="time">{{item.createTime | dateTimeToString}}</p>
                  <Button size="large" icon="ios-download-outline" @click.stop="uploadItem(item)" type="primary">{{item.name}}</Button>
                </TimelineItem>
              </Timeline>
            </Card>
          </div>
        </TabPane>
        <TabPane name="3" label="每日饮食问卷">
          <div v-if="tabsNum == 3" style="overflow-y: auto;" :style="{height: wrapHeight + 'px'}">
            <!--<vue-event-calendar :events="demoEvent" @dayChanged="" @monthChanged=""></vue-event-calendar>-->
            <Calendar
              v-on:choseDay="selDailyDate"
              style="max-width: 100%"
            ></Calendar>
            <Card style="margin: 10px 0">
              <div v-if="dailyQuestionnaireResult != null">
                <p class="questionnaireTitle">{{dailyQuestionnaireResult.name}}</p>
                <h4 style="text-align: center;padding: 10px 0px">{{dailyQuestionnaireResult.introduction}}</h4>
                <Divider>
                      <span style="font-size: 20px;color: #2d8cf0">
                          分数：{{dailyQuestionnaireResult.point}}
                      </span>
                </Divider>
                <div class="questionnaireQuestion">
                  <div style="width: 100%;padding: 15px 0" v-for="question in dailyQuestionnaireResult.questionVOList"
                       :key="question.id">
                    <div class="questionTitle">
                      <label v-if="question.required" style="color: red;position: absolute">*</label>
                      <div style="padding-left: 15px">
                        {{question.index}}、{{question.text}}
                        <span style="font-size: 16px;color: #B4B4B4;padding-left: 10px">({{question.type}})</span>
                      </div>
                    </div>
                    <div v-if="question.type == '文本'">
                      <div class="my_divz">{{question.optionList[0].answer}}</div>
                    </div>
                    <div v-if="question.type == '单选'">
                      <div style="padding-left: 30px">
                        <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList"
                             style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                            <span v-if="Option.isSelected" class="input_iocns">
                                                <i class="iconfont" style="font-size: 16px">&#xe735;</i>
                                            </span>
                          <span v-if="!Option.isSelected" class="input_iocns">
                                                <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                            </span>
                          <span style="font-size: 18px;padding-left: 10px">{{Option.text}}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="question.type == '多选'">
                      <div style="padding-left: 30px">
                        <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList"
                             style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                            <span v-if="Option.isSelected" class="input_iocns">
                                                <i class="iconfont" style="font-size: 16px">&#xe738;</i>
                                            </span>
                          <span v-if="!Option.isSelected" class="input_iocns">
                                                <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                            </span>
                          <span style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="question.type == '单选文本'">
                      <div style="padding-left: 30px">
                        <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList"
                             style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                            <span v-if="Option.isSelected" class="input_iocns">
                                                <i class="iconfont" style="font-size: 16px">&#xe735;</i>
                                            </span>
                          <span v-if="!Option.isSelected" class="input_iocns">
                                                <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                            </span>
                          <span v-if="Option.format ==''"
                                style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                          <span v-if="Option.format !=''"
                                style="font-size: 18px;padding-left: 10px;position: absolute;">
                                                <div v-if="Option.answer ==''" class="my_divz"
                                                     style="width: 200px;background-color: #f5f5f5">{{Option.answer}}</div>
                                                <div v-if="Option.answer !=''" class="my_divz" style="width: 200px">{{Option.answer}}</div>
                                            </span>
                        </div>
                      </div>
                    </div>
                    <div v-if="question.type == '多选文本'">
                      <div style="padding-left: 30px">
                        <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList"
                             style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                            <span v-if="Option.isSelected" class="input_iocns">
                                                <i class="iconfont" style="font-size: 16px">&#xe738;</i>
                                            </span>
                          <span v-if="!Option.isSelected" class="input_iocns">
                                                <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                            </span>
                          <span v-if="Option.format ==''"
                                style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                          <span v-if="Option.format !=''"
                                style="font-size: 18px;padding-left: 10px;position: absolute;">
                                                <div v-if="Option.answer ==''" class="my_divz"
                                                     style="width: 200px;background-color: #f5f5f5">{{Option.answer}}</div>
                                                <div v-if="Option.answer !=''" class="my_divz" style="width: 200px">{{Option.answer}}</div>
                                            </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Divider>
                      <span style="font-size: 20px;color: #2d8cf0">
                          填写时间：{{dailyQuestionnaireResult.operateTime | dateTimeToString}}
                      </span>
                </Divider>
              </div>
              <div v-else style="text-align: center">当日未填写饮食问卷</div>
            </Card>
          </div>
        </TabPane>
        <TabPane name="4" label="每日饮食分析">
          <div v-if="tabsNum == 4" style="overflow-y: auto;" :style="{height: wrapHeight + 'px'}">
            <Calendar
              v-on:choseDay="selDietLogDate"
              style="max-width: 100%"
            ></Calendar>
            <Card style="margin: 10px 0;">
              <div style="display: flex">
                <Table :columns="breakfastCol" :data="breakfastData" style="flex: 1"></Table>
                <Table :columns="lunchCol" :data="lunchData" style="flex: 1"></Table>
                <Table :columns="dinnerCol" :data="dinnerData" style="flex: 1"></Table>
                <Table :columns="otherCol" :data="otherData" style="flex: 1"></Table>
              </div>
            </Card>
            <Card style="margin: 10px 0">
              <Table :columns="nutrientAnalysisColumns" :data="nutrientAnalysisData"></Table>
            </Card>
          </div>
        </TabPane>
      </Tabs>
    </Card>
    </Col>
    <Modal v-model="modalDisplay" title="历史问卷结果" fullscreen footer-hide>
      <patient-questionnaire-result :user="user"></patient-questionnaire-result>
    </Modal>

  </Row>
</template>

<script>
  import prescription from './prescription'
  import patientQuestionnaireResult from './patientQuestionnaireResult.vue'
  import Viewer from 'viewerjs';
  import 'viewerjs/dist/viewer.css';
  import Calendar from 'vue-calendar-component'
  import {baseURL} from '../../json/common'
  import diagnoseHistory from './diagnose-history-simple.vue'

  export default {
    name: "medical_records",
    components: {
      prescription,
        patientQuestionnaireResult,
      Calendar,
        diagnoseHistory
    },
    data() {
      return {
          modalDisplay: false,
        wrapHeight: window.innerHeight - 168,
        user: null,
        tabsNum: 0,
        editable: false,
        questionnaireResult: {
          ABC: null,
          CARS: null,
          ATEC: null,
          CLSQ: null,
          stomach: null,
          evaluate: null,
        },
        questionnaireResultList: [],
        demoEvent: [
          {date: '2019/11/04', title: 'aaa'},
          {date: '2019/11/03', title: 'aaa'},
          {date: '2019/11/02', title: 'aaa'}
        ],
        breakfastCol: [
          {
            title: '早餐',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            render: (h, params) => {
              if (params.row.id != null) {
                return h('span', params.row.foodName + " * " + params.row.value + params.row.foodUnit)
              }
            }
          }
        ],
        breakfastData: [],
        lunchCol: [
          {
            title: '午餐',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            render: (h, params) => {
              if (params.row.id != null) {
                return h('span', params.row.foodName + " * " + params.row.value + params.row.foodUnit)
              }
            }
          },
        ],
        lunchData: [],
        dinnerCol: [
          {
            title: '晚餐',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            render: (h, params) => {
              if (params.row.id != null) {
                return h('span', params.row.foodName + " * " + params.row.value + params.row.foodUnit)
              }
            }
          },
        ],
        dinnerData: [],
        otherCol: [
          {
            title: '加餐',
            align: 'center',
            ellipsis: true,
            tooltip: true,
            render: (h, params) => {
              if (params.row.id != null) {
                return h('span', params.row.foodName + " * " + params.row.value + params.row.foodUnit)
              }
            }
          }
        ],
        otherData: [],
        dietDiaryColumns: [
          {
            title: '早餐'
          },
          {
            title: '午餐'
          },
          {
            title: '晚餐'
          },
          {
            title: '加餐'
          },
        ],
        dietDiaryData: [],
        nutrientAnalysisColumns: [
          {
            type: 'index',
            width: 80,
            align: 'center',
          },
          {
            title: '营养物质',
            align: 'center',
            render: (h, params) => {
//                            if (params.row.foodId != null) {
//                                return h('span',params.row.nutritionTypeName+"("
//                                    + params.row.nutritionTypeEngName + "-"+ params.row.nutritionForShort +")")
//                            }
              return h('span', params.row.nutritionTypeName + "("
                + params.row.nutritionTypeEngName + "-" + params.row.nutritionForShort + ")")
            }
          },
          {
            title: '摄入量',
            align: 'center',
            render: (h, params) => {
//                            if (params.row.foodId != null) {
//                                if (params.row.compare == 'down') {
//                                    return h('span', {style: {color: '#ed4014'}}, params.row.sumGetValue + " " + params.row.nutritionUnit)
//                                } else {
//                                    return h('span', {style: {color: '#19be6b'}}, params.row.sumGetValue + " " + params.row.nutritionUnit)
//                                }
//                            }
              if (params.row.compare == 'down') {
                return h('span', {style: {color: '#ed4014'}}, params.row.sumGetValue ? params.row.sumGetValue : 0 + " " + params.row.nutritionUnit)
              } else {
                return h('span', {style: {color: '#19be6b'}}, params.row.sumGetValue ? params.row.sumGetValue : 0 + " " + params.row.nutritionUnit)
              }
            }
          },
          {
            title: '推荐量',
            align: 'center',
            render: (h, params) => {
                if (params.row.goalValue != null) {
                    return h('span', params.row.goalValue + " " + params.row.nutritionUnit)
                }
//              return h('span', params.row.goalValue ? params.row.goalValue + " " + params.row.nutritionUnit : '-' + " " + params.row.nutritionUnit)
            }
          },
        ],
        nutrientAnalysisData: [],
        caseData: null,
        caseInfo: {},
        systemReport: [],
        dietLogData: [],
        dailyQuestionnaireResult: {},
          unAnswerQuestionnaire: null,
          sendMessage: false,
          isAutism: false,
          viewerDom: null
      }
    },
    created() {
      this.user = this.$store.state.currentPatient
      if (this.user == null) {
        this.$Notice.error({title: '数据异常，请重新登录'})
          this.$router.push('/')
        return
      }

      this.user['age'] = this.getAgeByBirthday(this.user.birthday)

      this.getUserCase()
      this.getSystemMedicalReport()
        this.getUnAnserQuestionnaire()
    },
    methods: {
        checkUser () {
            if (this.user == null || this.user.id == null){
                this.$Notice.error({title: '请重新登录'})
                this.$router.push('/')
                return
            }
        },
        remindUserToAnswer() {
            this.sendMessage = true
            this.$http.post('user/questionnaireRemind', {
                userId: this.user.id
            }).then(function (res) {
                let msg = res.body
                if (msg.success) {
                    this.sendMessage = true
                    this.$Notice.success({title: '短信发送成功'})
                } else {
                    this.$Notice.error({title: '短信发送失败'})
                    this.sendMessage = false
                }
            }, function (res) {
                this.myError(res.body)
                this.sendMessage = false
            })
        },
      // 获取系统检测报告
      getSystemMedicalReport() {
          this.checkUser()
        this.$http.post('medicalReport/list', {
          userId: this.user.id,
          isDeleted: false
        }).then(function (res) {
          let msg = res.body
          console.log(res)
          if (msg.success) {
            this.systemReport = msg.data.list
          } else {
          }
        }, function (res) {
          this.infoLoading = false
          this.myError(res.body)
        })
      },
      // 选择每日饮食问卷
      selDailyDate(date) {
          this.checkUser()
        this.$http.post('questionnaire/getDailyQuestionnaireResult', {
          userId: this.user.id,
          date: date,
        }).then(function (res) {
          this.tableLoading = false
          let msg = res.body
          if (msg.success) {
              if (msg.data != null && msg.data.length > 0){
                  this.dailyQuestionnaireResult = msg.data[0]
              }
              else {
                  this.dailyQuestionnaireResult = null
              }
          } else {
            this.$Notice.error({title: '每日饮食查询失败', desc: msg.message});
          }
        }, function (res) {
          this.tableLoading = false
          this.myError(res.body)
        })
      },
      selDietLogDate(date) {
        this.breakfastData = []
        this.lunchData = []
        this.dinnerData = []
        this.otherData = []
        this.nutrientAnalysisData = []
        this.getDietLog(date)
        this.getDietLogAnalysis(date)
      },
      getDietLog(data) {
          this.checkUser()
        this.$http.post('dietLog/list', {
          userId: this.user.id,
          date: data,
        }).then(function (res) {
          this.tableLoading = false
          let msg = res.body
          if (msg.success) {
            for (let i = 0; i < msg.data.list.length; i++) {
              let item = msg.data.list[i].dietLogInfoDateList[0]
              for (let j = 0; j < item.dietLogVOList.length; j++) {
                let dietLog = item.dietLogVOList[j]
//                                dietLog.type.substr(item.type.length - 1, 1)
                switch (dietLog.type.substr(dietLog.type.length - 1, 1)) {
                  case '1':
                    this.breakfastData = this.breakfastData.concat(dietLog.dietLogInfoList)
                    break;
                  case '2':
                    this.lunchData = this.lunchData.concat(dietLog.dietLogInfoList)
                    break;
                  case '3':
                    this.dinnerData = this.dinnerData.concat(dietLog.dietLogInfoList)
                    break;
                  case '4':
                    this.otherData = this.otherData.concat(dietLog.dietLogInfoList)
                    break;
                  default:
                    break;
                }
              }
            }
            if (this.breakfastData.length <= 0 && this.lunchData.length <= 0 && this.dinnerData.length <= 0 && this.other.length <= 0) {
              this.$Notice.warning({title: '当日未填写饮食日志', desc: msg.message});
            }
          } else {
            this.$Notice.error({title: '每日饮食查询失败', desc: msg.message});
          }
        }, function (res) {
          this.tableLoading = false
          this.myError(res.body)
        })
      },
        // 获取待填写问卷
        getUnAnserQuestionnaire () {
            this.checkUser()
            this.$http.post('questionnaire/getMRQuestionnaire', {
                userId: this.user.id
            }).then(function (res) {
                let msg = res.body
                if (msg.success) {
                    console.log('待填写', msg.data)
                    this.unAnswerQuestionnaire = msg.data
                } else {
                }
            }, function (res) {
                this.myError(res.body)
            })
        },
      // 获取每日饮食分析
      getDietLogAnalysis(data) {
          this.checkUser()
        this.$http.post('dietLog/pcAnalyzeDietLog', {
          userId: this.user.id,
          date: data,
        }).then(function (res) {
          this.tableLoading = false
          let msg = res.body
          if (msg.success) {
//                        this.nutrientAnalysisData = msg.data
            for (let i = 0; i < msg.data.length; i++) {
              let item = msg.data[i]
              if (item != null && item.nutritionTypeId != null) {
                this.nutrientAnalysisData.push(item)
              }
            }
          } else {
            this.$Notice.error({title: '每日饮食查询失败', desc: msg.message});
          }
        }, function (res) {
          this.tableLoading = false
          this.myError(res.body)
        })
      },
        // 获取病历关联的问卷结果
      infoItem() {
        this.infoLoading = true
        this.$http.post('medicalRecord/getQuestionnaireResult', {
          userId: this.user.id,
          medicalRecordId: this.caseData.id
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.questionnaireResultList = msg.data.list
          } else {
            this.$Notice.error({title: '问卷结果查询失败', desc: msg.message});
          }
        }, function (res) {
          this.infoLoading = false
          this.myError(res.body)
        })
      },
      // 获取最近一条病历
      getUserCase() {
            this.checkUser()
        this.infoLoading = true
        this.$http.post('medicalRecord/getResult', {
          userId: this.user.id,
          isFirst: true,
          pageSize: 1
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            if (msg.data.list != null && msg.data.list.length > 0) {
              this.caseData = msg.data.list[0]
              this.infoItem();
              this.caseInfo = JSON.parse(this.caseData.result)
              console.log(this.caseInfo)
            }
          } else {
            this.$Notice.error({title: '病历查询失败', desc: msg.message});
          }
        }, function (res) {
          this.infoLoading = false
          this.myError(res.body)
        })
      },
      initImageTools() {
            console.log('clickTab', this.tabsNum)
            if (this.tabsNum == 2) {
                console.log('111')
                //初始化 viewerjs
                setTimeout(()=>{
                    this.ViewerDom = document.getElementById('imgToolsHistory');
                    const viewer = new Viewer(this.ViewerDom, {
                        url: "data-original",
                        show: function () {
                            viewer.update()
                        }
                    });
                }, 300)
            }

      },
      // 保存病历的修改
      saveCase() {
        this.$http.post('medicalRecord/updateResult', {
          id: this.caseData.id,
          result: JSON.stringify(this.caseInfo),
            isAutism: this.isAutism
        }).then(function (res) {
          let msg = res.body
          if (msg.success) {
            console.log(msg.data)
            this.editable = false
              this.$Notice.success({title: '保存成功'});
          } else {
            this.$Notice.error({title: '保存失败', desc: msg.message});
          }
        }, function (res) {
          this.infoLoading = false
          this.myError(res.body)
        })
      },
      // 根据生日获取年龄
      getAgeByBirthday(birthday) {
        if (!birthday) {
          return
        }
        let returnAge;
        let strBirthdayArr = birthday.split("-");
        let birthYear = strBirthdayArr[0];
        let birthMonth = strBirthdayArr[1];
        let birthDay = strBirthdayArr[2];

        let d = new Date();
        let nowYear = d.getFullYear();
        let nowMonth = d.getMonth() + 1;
        let nowDay = d.getDate();

        if (nowYear == birthYear) {
          returnAge = 0;//同年 则为0岁
        } else {
          let ageDiff = nowYear - birthYear; //年之差
          if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
              let dayDiff = nowDay - birthDay;//日之差
              if (dayDiff < 0) {
                returnAge = ageDiff - 1;
              } else {
                returnAge = ageDiff;
              }
            } else {
              let monthDiff = nowMonth - birthMonth;//月之差
              if (monthDiff < 0) {
                returnAge = ageDiff - 1;
              } else {
                returnAge = ageDiff;
              }
            }
          } else {
            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
          }
        }

        return returnAge;//返回周岁年龄
      },
      //病历下载
      uploadItem(item){
          let eleLink = document.createElement('a')
          eleLink.href = baseURL + item.url
          let suffix = item.url.substring(item.url.lastIndexOf('.'), item.url.length)
          eleLink.download = item.name + suffix
          eleLink.target = '_blank'
          eleLink.style.display = 'none'
          document.body.appendChild(eleLink)
          eleLink.click()
          document.body.removeChild(eleLink)
      },
        //病史附件下载
        downloadItem(item){
          console.log('item', item)
            let eleLink = document.createElement('a')
            eleLink.href = baseURL + item
            let suffix = item.substring(item.lastIndexOf('.'), item.length)
            eleLink.download = '病史附件' + suffix
            eleLink.target = '_blank'
            eleLink.style.display = 'none'
            document.body.appendChild(eleLink)
            eleLink.click()
            document.body.removeChild(eleLink)
        },
        // 查看患者的历史问卷结果
        goQuestionnaireResult () {
            this.$router.push({name: 'patientQuestionnaireResult', params:{patient: this.user}})
        },
    }
  }
</script>

<style scoped>
  >>> .ivu-tabs-bar {
    margin: 0;
  }

  >>> .ivu-tabs-tabpane {
    background: #fff;
    padding: 20px;
    border-left: 1px solid #dcdee2;
    border-right: 1px solid #dcdee2;
    border-bottom: 1px solid #dcdee2;
  }

  .questionnaireTitle {
    text-align: center;
    font-size: 42px;
    font-weight: bold;
  }

  .questionnaireQuestion {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 30px;
  }

  .questionTitle {
    font-size: 20px;
    line-height: 50px;
    letter-spacing: 3px;
    position: relative;
  }

  .my_Button {
    height: 45px;
    border: 0;
    padding: 5px 13px 6px;
    background-color: rgba(0, 0, 0, 0);
  }

  .my_Button:focus {
    box-shadow: 0 0 0 0;
  }

  .my_divz {
    height: 35px;
    padding: 4px 7px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    background-color: #fff;
    line-height: 27px;
    font-size: 18px;
  }

  .time {
    font-size: 14px;
    font-weight: bold;
  }

  >>> .cal-wrapper {
    width: 100%;
    padding: 0;
  }

  >>> .events-wrapper {
    display: none;
  }

  >>> .wh_content_item .wh_isToday {
    background: #c0cc27;
  }

  >>> .ivu-card-head p, .ivu-card-head-inner{
    height: 40px;
  }

  .group-row {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
</style>
